/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect, useRef } from "react"
import PropTypes from 'prop-types'
import Header from '../header'
import Footer from '../footer'
import { useLocation } from "@reach/router"

// import { SSRProvider } from "react-bootstrap"
const RequestQuote = React.lazy(() => import('../request-a-quote'))

const Layout = ({ children, headerClass }) => {

  const location = useLocation();
  const pathnameRef = useRef(location.pathname);

  useEffect(() => {
    sessionStorage.setItem('previous_url', pathnameRef.current)
  }, [])

  return (
    <>
      {/* <SSRProvider> */}
      <div className='wrapper'>
        <div className={`transparent-header ${headerClass}`}>
          <Header />
        </div>
        <main className='main-container'>
          {children}
          <RequestQuote />
        </main>
        <Footer />
      </div>
      {/* </SSRProvider> */}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  headerClass: PropTypes.string
}

Layout.defaultProps = {
  headerClass: ''
}

export default Layout
